"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var component_1 = require("../../helpers/component");
var focuseableHOC = function (Component) {
    var Focuseable = function (_a) {
        var className = _a.className, onFocus = _a.onFocus, onBlur = _a.onBlur, onMouseUp = _a.onMouseUp, rest = __rest(_a, ["className", "onFocus", "onBlur", "onMouseUp"]);
        var _b = react_1.useState(false), keyboardFocus = _b[0], setKeyboardFocus = _b[1];
        var onFocusHandler = function (event) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            if (onFocus) {
                onFocus.apply(void 0, __spreadArray([event], args));
            }
            setKeyboardFocus(true);
        };
        var onBlurHandler = function (event) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            if (onBlur) {
                onBlur.apply(void 0, __spreadArray([event], args));
            }
            setKeyboardFocus(false);
        };
        var onMouseUpHandler = function (event) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            if (onMouseUp) {
                onMouseUp.apply(void 0, __spreadArray([event], args));
            }
            setKeyboardFocus(false);
        };
        return (react_1["default"].createElement(Component, __assign({ tabIndex: !keyboardFocus ? '0' : '-1', className: [keyboardFocus && 'keyboard-focus', className], onFocus: onFocusHandler, onBlur: onBlurHandler, onMouseUp: onMouseUpHandler }, rest)));
    };
    return component_1.hoist(Focuseable, Component);
};
exports["default"] = focuseableHOC;
//# sourceMappingURL=focuseable.js.map